import { CountdownTimer } from '@/components/common/count-down-timer'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { formatPrice } from '@/lib/utils'
import { FlashSaleProduct } from '@/types/flash-sale'
import Image from 'next/image'

interface ProductInfoFlashSaleProps {
  endsAt: Date
  product: FlashSaleProduct
}

export const ProductInfoFlashSale = ({
  endsAt,
  product,
}: ProductInfoFlashSaleProps) => {
  return (
    <div className='mt-4 flex w-full flex-col'>
      <div className='flex items-center justify-between rounded-t-lg bg-gradient-to-r from-blue-200 to-blue-600 px-4 py-1'>
        <Image
          src={ImageHelper.getImageUrlCdn('/image/July2023/mceclip0.png')}
          alt='flash sale'
          width={100}
          height={20}
          className='h-4 w-auto object-contain'
          unoptimized
        />

        <div className='flex items-center gap-2'>
          <div className='hidden text-xs uppercase text-white md:block'>
            Kết thúc trong
          </div>
          <div className='font-medium text-white md:text-lg'>
            <CountdownTimer expiryTimestamp={endsAt} />
          </div>
        </div>
      </div>

      <div className='rounded-b-lg border border-blue-200 bg-white px-4 py-1 md:px-5 md:py-3'>
        <div className='flex items-center gap-2'>
          <div className='text-lg font-bold text-neutral-900 md:text-2xl'>
            {formatPrice(product.regular_price)}
          </div>
          <div className='text-sm text-neutral-400 line-through md:text-base'>
            {formatPrice(product.compare_price)}
          </div>
        </div>
      </div>
    </div>
  )
}
